import { Capacitor } from '@capacitor/core';

/**
 * Detecta de forma exhaustiva si la aplicación se ejecuta dentro de un contenedor móvil nativo
 * (Capacitor Android / iOS WebView).
 */
export const isNativePlatform = () => {
    if (typeof window === 'undefined') return false;

    // 1. Verificación oficial de Capacitor
    try {
        if (Capacitor && typeof Capacitor.isNativePlatform === 'function' && Capacitor.isNativePlatform()) {
            return true;
        }
    } catch (e) {
        // Ignorar si falla la llamada
    }

    // 2. Protocolo nativo de Capacitor
    if (window.location.protocol === 'capacitor:') {
        return true;
    }

    // 3. En Android WebView con androidScheme="https", el hostname es 'localhost' y el puerto es vacío ""
    // En cambio, desarrollo en PC usa localhost:3000 o localhost:8002
    if (window.location.hostname === 'localhost' && window.location.port !== '3000' && window.location.port !== '8002') {
        return true;
    }

    // 4. Bandera global inyectada por Capacitor
    if (window.Capacitor && window.Capacitor.platform && window.Capacitor.platform !== 'web') {
        return true;
    }

    return false;
};

/**
 * Determina si el panel simulador (GPS / Hora) debe habilitarse.
 * 
 * REGLAS ESTRICTAS:
 * - NUNCA se activa en dispositivos móviles nativos (APK / iOS).
 * - NUNCA se activa si el entorno está en producción (REACT_APP_ENV === 'production').
 * - Solo se permite en navegador de escritorio cuando estamos en staging (/staging o REACT_APP_ENV === 'staging')
 *   o en desarrollo local (puerto 3000).
 */
export const isSimulatorAllowed = () => {
    // Jamás en la aplicación nativa instalada en el dispositivo
    if (isNativePlatform()) {
        return false;
    }

    // Jamás en producción
    if (process.env.REACT_APP_ENV === 'production') {
        return false;
    }

    const isStagingEnv = 
        process.env.REACT_APP_ENV === 'staging' ||
        (typeof window !== 'undefined' && window.location.pathname.startsWith('/staging'));

    const isLocalDevServer = 
        typeof window !== 'undefined' &&
        (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') &&
        window.location.port === '3000';

    return isStagingEnv || isLocalDevServer;
};
